import React from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import {
  ModalContent,
  DictionaryText,
  WhatIsThisModalWithHeader,
  DictionaryMedia,
  DictionaryMediaImage,
} from './styles';

const DictionaryModal = (props) => {
  const {
    videoId,
    mediaUrl, open, handleClose, term, definition, header,
  } = props;

  const renderDictionaryMedia = () => {
    if (videoId) {
      return (
        <div className="config-dictionary-media">
          <div id="lcVideoWrapper" />
        </div>
      );
    }
    if (mediaUrl) {
      return (
        <DictionaryMedia>
          <DictionaryMediaImage src={mediaUrl} alt={term} />
        </DictionaryMedia>
      );
    }

    return null;
  };

  if (!open) return null;

  return createPortal(
    <WhatIsThisModalWithHeader onClose={(e) => handleClose(e)} header={header || term}>
      <ModalContent>
        {renderDictionaryMedia()}
        <DictionaryText>
          <ReactMarkdown source={definition} />
        </DictionaryText>
      </ModalContent>
    </WhatIsThisModalWithHeader>,
    document.body
  );
};

DictionaryModal.defaultProps = {
  videoId: '',
  header: undefined,
};

DictionaryModal.propTypes = {
  term: PropTypes.string.isRequired,
  definition: PropTypes.string.isRequired,
  mediaUrl: PropTypes.string.isRequired,
  videoId: PropTypes.string,
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  header: PropTypes.string,
};

export default DictionaryModal;
